"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles aria-hidden for dialogs.
 */
var AriaIsolate =
/*#__PURE__*/
function () {
  function AriaIsolate(el) {
    _classCallCheck(this, AriaIsolate);

    if (!(el instanceof HTMLElement)) {
      throw new Error('AriaIsolate must be instantiated with a valid HTML element');
    }

    this.element = el;
    this.affectedElements = [];
  }
  /**
   * applies aria-hidden to everything except direct parents of `this.element`
   */


  _createClass(AriaIsolate, [{
    key: "activate",
    value: function activate() {
      var _this = this;

      var parent = this.element.parentNode;

      while (parent && parent.nodeName !== 'HTML') {
        Array.prototype.slice.call(parent.children).forEach(function (child) {
          if (child !== _this.element && !child.contains(_this.element)) {
            if (child.getAttribute('aria-hidden') === 'true') {
              return;
            }

            _this.affectedElements.push(child);

            child.setAttribute('aria-hidden', 'true');
          }
        });
        parent = parent.parentNode;
      }
    }
    /**
     * restores aria-hidden state by removing aria-hidden="true"
     * from everything affected by 'activate'
     */

  }, {
    key: "deactivate",
    value: function deactivate() {
      this.affectedElements.forEach(function (affected) {
        return affected.removeAttribute('aria-hidden');
      });
      this.affectedElements = [];
    }
  }]);

  return AriaIsolate;
}();

exports["default"] = AriaIsolate;